<template>
  <div class="sideBar" id="domSideBar">
    <el-scrollbar>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        background-color="#fff"
        text-color="#333"
        active-text-color="#1F74FF"
        mode="vertical"
        :collapse-transition="false"
        :collapse="opened"
      >
        <sidebar-item v-for="item in routes" :key="item.path" :item="item" :basePath="item.path"></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from "./SideBarItem";
import { mapGetters } from "vuex";
import { currencyRoutes } from "../../router/index";

export default {
  data() {
    return {
      opened: false
    };
  },
  created() {
    //console.log(currencyRoutes);
  },
  components: { SidebarItem },
  computed: {
    // ...mapGetters(['routes', 'opened']),
    // booleanOpen() {
    //   return this.opened === 'true' ? true : false
    // },
    activeMenu() {
      return this.$route.path;
    },
    routes() {
      return global.antRouter;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/sideBar/index.vue